<div *ngIf="slotListArray.groups.standard.length" class="interval-type">
  <div class="select">
    <sd-radio name="intervalType" [formControl]="intervalTypeControl" [value]="intervalType.Standard">
      Стандартная доставка
    </sd-radio>
    <span class="price">{{ slotListArray.groups.standard | minimalPrice }} ₽</span>
  </div>
  <div *ngIf="intervalTypeControl.value === intervalType.Standard" class="time-slots-standard">
    <sd-time-slot-groups-info class="info">Не нужно ждать дома, позвоним за час</sd-time-slot-groups-info>
    <sd-time-slot-groups-tab
      *ngFor="let slot of slotListArray.groups.standard"
      [timeSlot]="slot"
      [active]="isTimeSlotActive(slot)"
      (click)="selectTimeSlot.emit(slot)"
    ></sd-time-slot-groups-tab>
  </div>
</div>

<div *ngIf="slotListArray.groups.nextNHours.length" class="interval-type">
  <div class="select">
    <sd-radio name="intervalType" [formControl]="intervalTypeControl" [value]="intervalType.NextNHours">
      {{ slotListArray.groups.nextNHours | nextNHours }}
    </sd-radio>
    <span class="price">{{ slotListArray.groups.nextNHours | minimalPrice }} ₽</span>
  </div>
</div>

<div *ngIf="slotListArray.groups.withinADay.length" class="interval-type">
  <div class="select">
    <sd-radio name="intervalType" [formControl]="intervalTypeControl" [value]="intervalType.WithinADay">
      В течение дня
    </sd-radio>
    <span class="price">{{ slotListArray.groups.withinADay | minimalPrice }} ₽</span>
  </div>
</div>

<div *ngIf="slotListArray.groups.footCourier.length" class="interval-type">
  <div class="select">
    <sd-radio name="intervalType" [formControl]="intervalTypeControl" [value]="intervalType.FootCourier">
      Курьер
    </sd-radio>
    <span class="price">{{ slotListArray.groups.footCourier | minimalPrice }} ₽</span>
  </div>
  <div *ngIf="intervalTypeControl.value === intervalType.FootCourier" class="time-slots-just-in-time">
    <sd-time-slot-groups-select
      [timeSlots]="slotListArray.groups.footCourier"
      [activeIndex]="timeSlotActiveIndex(slotListArray.groups.footCourier)"
      (selectTimeSlot)="selectTimeSlot.emit($event)"
    ></sd-time-slot-groups-select>
  </div>
</div>

<div *ngIf="slotListArray.groups.justInTime.length" class="interval-type">
  <div class="select">
    <sd-radio name="intervalType" [formControl]="intervalTypeControl" [value]="intervalType.JustInTime">
      Точно ко времени
    </sd-radio>
    <span class="price">{{ slotListArray.groups.justInTime | minimalPrice }} ₽</span>
  </div>
  <div *ngIf="intervalTypeControl.value === intervalType.JustInTime" class="time-slots-just-in-time">
    <sd-time-slot-groups-select
      [timeSlots]="justInTimeTimeSlots(slotListArray.groups.justInTime)"
      [activeIndex]="timeSlotActiveIndex(slotListArray.groups.justInTime)"
      (selectTimeSlot)="selectTimeSlot.emit($event)"
    ></sd-time-slot-groups-select>
  </div>
</div>

<div *ngIf="slotListArray.groups.manipulator.length" class="interval-type">
  <div class="select">
    <sd-radio name="intervalType" [formControl]="intervalTypeControl" [value]="intervalType.Manipulator">
      Доставка и разгрузка манипулятором
    </sd-radio>
    <span class="price">{{ slotListArray.groups.manipulator | minimalPrice }} ₽</span>
  </div>
  <div *ngIf="intervalTypeControl.value === intervalType.Manipulator" class="time-slots-manipulator">
    <sd-time-slot-groups-info class="info">Необходим стропальщик со стороны клиента</sd-time-slot-groups-info>
    <sd-time-slot-groups-tab
      *ngFor="let slot of slotListArray.groups.manipulator"
      [timeSlot]="slot"
      [active]="isTimeSlotActive(slot)"
      (click)="selectTimeSlot.emit(slot)"
    ></sd-time-slot-groups-tab>
  </div>
</div>
